import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ColetorCustosService } from 'src/app/_services';
import { FileUploadModel, RateioDespesas, ColetorCustos } from 'src/app/_models';
import {HttpClient} from '@angular/common/http';
import * as XLSX from 'xlsx';
import { FundoFixoComponent } from '../../_components/fundo-fixo/fundo-fixo.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { PopUpColetoresComponent } from '../popupColetores/popupColetores.component';
import { AppComponent } from '../../app.component';
import { DocumentoService } from 'src/app/_services/documento.service';

@Component({
  selector: 'app-planilha-fundo-fixo',
  templateUrl: './planilha-fundo-fixo.component.html',
  styleUrls: ['./planilha-fundo-fixo.component.css']
})
export class PlanilhaFundoFixoComponent implements OnInit {
  type: string;
  private files: Array<FileUploadModel> = [];
  arrayBuffer: any;
  rateioDespesas = {} as RateioDespesas;
  lstRateiosDespesas = new Array<RateioDespesas>();
  coletoresCusto: ColetorCustos[];
  coletoresCustoError = new Array<ColetorCustos>();

  /** Link text */
  @Input() text = 'Upload';
  /** Name used in form which will be sent in HTTP request. */
  @Input() param = 'file';
  /** Target URL for file uploading. */
  @Input() target = 'https://file.io';
  /** File extension that accepted, same as 'accept' of <input type="file" />. 
      By the default, it's set to 'image/*'. */
  @Input() accept = '.xlsx';
  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  @Output() complete = new EventEmitter<string>();


  constructor(
    private loadComponent: AppComponent,
    private documentoService: DocumentoService,
    private _http: HttpClient,
    private protocolo: FundoFixoComponent,
    private apiColetorCustos: ColetorCustosService,
    private dialog?: MatDialog,
  ) { }

  ngOnInit() {
    this.type = this.type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  getFile() {
    this.documentoService.getPlanilhaRateio().subscribe(respData => {
      this.downLoadFile(respData, this.type);
    }, error => {

    });
  }

  downLoadFile(data: any, type: string) {
    var blob = new Blob([data], { type: type.toString() });
    var url = window.URL.createObjectURL(blob);
    var pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert('Desative o bloqueador de pop-ups e tente novamente.');
    }
  }

  AnexarPlanilha() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        const file = fileUpload.files[index];
        this.files.push({
          data: file, state: 'in',
          inProgress: false, progress: 0, canRetry: false, canCancel: true
        });
      }
      this.uploadFiles();
    };
    fileUpload.click();
  }

  private uploadFile(file: FileUploadModel) {
    let fileReader = new FileReader();
    let codDespesaNaoEncontrado: string = "";
    let descricaoNaoEncontrado: boolean = false;
    let tipoColetorNaoEncontrado: boolean = false;

    fileReader.onload = (e) => {
      this.loadComponent.startLoading(true);
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];
      let jsonPlanilha: Array<any>;
      jsonPlanilha = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      jsonPlanilha.forEach((p, index) => {
        this.rateioDespesas = {} as RateioDespesas;
        this.rateioDespesas.codDespesa = p.COD_DESPESA;

        if (this.protocolo.despesasfundoFixo.find(td => td.numTransacao == p.COD_DESPESA) != null)
          this.rateioDespesas.nomeTipoDespesa = this.protocolo.despesasfundoFixo.find(td => td.numTransacao == p.COD_DESPESA).nomeTransacao;
        else {
          codDespesaNaoEncontrado = p.COD_DESPESA;
          return;
        }

        if(p.TIPOCOLETOR == null || p.TIPOCOLETOR == 'undefined' || p.TIPOCOLETOR == ''){
          tipoColetorNaoEncontrado = true;
          return;
        }
        else{
          this.rateioDespesas.codTipoColetor = p.TIPOCOLETOR.toUpperCase().replace(' ', '');
          this.rateioDespesas.identificacaoColetor = p.COLETOR;
          this.rateioDespesas.contaRazao = this.protocolo.despesasfundoFixo.find(td => td.numTransacao == p.COD_DESPESA).contaContabil;
        }
        
        if (p.DESCRICAO == null || p.DESCRICAO.value == ''){
          descricaoNaoEncontrado = true;
          return;
        }
        else
          this.rateioDespesas.descricao = p.DESCRICAO;

        this.rateioDespesas.usuarioAlteracao = this.protocolo.currentUser.login;
        this.rateioDespesas.usuarioCadastro = this.protocolo.currentUser.login;
        this.rateioDespesas.valor = Number(p.VALOR.toFixed(2));

        if(!tipoColetorNaoEncontrado){
          if (this.rateioDespesas.codTipoColetor.toUpperCase().replace(' ', '') == 'N')
            this.rateioDespesas.operacaoSubNumero = p.OPERACAO;

          this.lstRateiosDespesas.push(this.rateioDespesas);
        }
      });

      //Valores de rateios
      var valRateioProtoloco = this.protocolo.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
      var valRateioDespesas = this.lstRateiosDespesas.reduce((sum, c) => sum + c.valor, 0);
      var totalRateios = (Number(valRateioProtoloco.toFixed(2)) + Number(valRateioDespesas.toFixed(2)));

      if (totalRateios > this.protocolo.valorRateio) {
        this.protocolo.ExibeMensagemValorRateios();
        this.rateioDespesas = {} as RateioDespesas;
        this.lstRateiosDespesas = new Array<RateioDespesas>();
        this.loadComponent.startLoading(false);
      }
      else{
        this.ValidarDadosRateio(this.lstRateiosDespesas);
      }

      if (codDespesaNaoEncontrado != "") {
        this.protocolo.ExibeMensagemUpload("Erro ao realizar upload da planilha",`Código de despesa ${codDespesaNaoEncontrado} não encontrado para o tipo de documento selecionado.`);
        this.rateioDespesas = {} as RateioDespesas;
        this.lstRateiosDespesas = new Array<RateioDespesas>();
        this.loadComponent.startLoading(false);
      }

      if (descricaoNaoEncontrado) {
        this.protocolo.ExibeMensagemUpload("Erro ao realizar upload da planilha",`Descrição não pode ser um campo vazio.`);
        this.rateioDespesas = {} as RateioDespesas;
        this.lstRateiosDespesas = new Array<RateioDespesas>();
        this.loadComponent.startLoading(false);
      }

      if(tipoColetorNaoEncontrado){
        this.protocolo.ExibeMensagemUpload("Erro ao realizar upload da planilha",`Coluna "TIPOCOLETOR" com registro(s) vazio ou nulo.`);
        this.rateioDespesas = {} as RateioDespesas;
        this.lstRateiosDespesas = new Array<RateioDespesas>();
        this.loadComponent.startLoading(false);
      }

      this.removeFileFromArray(file);

    }
    fileReader.readAsArrayBuffer(file.data);
  }

  private IncluirRateioDataSource() {
    
    this.lstRateiosDespesas.forEach(r => this.protocolo.lstRateioDespesas.push(r));

    this.protocolo.dataSource = new MatTableDataSource<RateioDespesas>(this.protocolo.lstRateioDespesas);
    this.protocolo.dataSource.paginator = this.protocolo.paginator;

    this.protocolo.somaRateio = this.protocolo.lstRateioDespesas.reduce((sum, c) => sum + c.valor, 0);
    this.protocolo.somaRateio = Number(this.protocolo.somaRateio.toFixed(5));
    this.rateioDespesas = {} as RateioDespesas;
    this.lstRateiosDespesas = new Array<RateioDespesas>();
    this.loadComponent.startLoading(false);
  }

  ValidarDadosRateio(rateios: RateioDespesas[]) {
    this.apiColetorCustos.validateColetoresCustos(rateios, this.protocolo.empresaMRV.codigoEmp, null, this.protocolo.formFundoFixo.frmFXFundoFixo.value, "01")
      .subscribe(
        data => this.coletoresCusto = data.data,
        err => {
          console.error(err);
          this.loadComponent.startLoading(false);
        },
        () => {
          if (this.coletoresCusto != null) {
            this.VerificaColetoresInvalidos(this.coletoresCusto);
            this.protocolo.verifingColetor = false;
          }

          this.loadComponent.startLoading(false);
        });
  }

  private VerificaColetoresInvalidos(coletores: ColetorCustos[]) {
    let idx: number = 0;
    this.coletoresCustoError = new Array<ColetorCustos>();

    coletores.forEach(cc => {
      idx ++;
      console.log(cc.status);
      if (cc.status == "E")
        this.coletoresCustoError.push(cc);
    });

    if (this.coletoresCustoError.length > 0)
    {
      this.dialog.open(PopUpColetoresComponent, { data: this.coletoresCustoError });
      this.lstRateiosDespesas = new Array<RateioDespesas>();
    }
    else
      this.IncluirRateioDataSource();
  }

  private removeFileFromArray(file: FileUploadModel) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

  private uploadFiles() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.value = '';

    this.files.forEach(file => {
      this.uploadFile(file);
    });
  }
}
